// The how-to-play content that has to stay in sync with the engine.
//
// The prose in index.html is stable; the command list is not, so it is generated from COMMANDS
// rather than written out. A seventh command cannot appear in the engine, and therefore on the
// command bar, without also appearing in the help.

import { COMMANDS, COMMAND_HELP, COMMAND_LABELS } from '../engine/commands'
import { COMMAND_GLYPHS } from './glyphs'

export function renderCommandHelp(el: HTMLElement): void {
  // The same glyph as the bar, beside the words that explain it — this is where the player learns
  // to read the shapes, so showing a different mark here would defeat the point of having them.
  el.innerHTML = COMMANDS.map(
    (c) => `<dt>${COMMAND_GLYPHS[c]}<span>${COMMAND_LABELS[c]}</span></dt><dd>${COMMAND_HELP[c]}</dd>`,
  ).join('')
}
